import styled from '@emotion/styled';

interface ButtonProps {
  size?: 'auto' | 'full' | 'md' | 'smd' | 'sm' | 'lg';
  variant?: 'primary' | 'secondary' | 'danger' | 'success' | 'transparent';
  children: React.ReactNode;
  disabled?: boolean;
}

const Button = styled.button<ButtonProps>`
  height: 44px;
  border-radius: 8px;
  padding: 0 10px;
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 30px;
  text-align: center;
  text-underline-position: from-font;
  user-select: none;
  text-decoration-skip-ink: none;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  transition:
    background-color 0.3s,
    filter 0.2s ease;
  overflow: hidden;
  white-space: nowrap;

  width: ${({ size = 'auto' }) => (size === 'full' ? '100%' : 'auto')};

  background-color: ${({ variant = 'primary', disabled }) =>
    disabled
      ? '#F2F2F3'
      : variant === 'primary'
        ? 'var(--prim4)'
        : variant === 'secondary'
          ? 'var(--white)'
          : variant === 'danger'
            ? '#ff4d4f'
            : variant === 'transparent'
              ? 'none'
              : variant === 'success'
                ? '#52c41a'
                : 'var(--prim4)'};

  color: ${({ variant = 'primary', disabled }) =>
    disabled
      ? '#7D7986'
      : variant === 'primary' || variant === 'danger' || variant === 'success'
        ? 'var(--white)'
        : variant === 'transparent'
          ? 'none'
          : 'var(--t-black)'};

  border: 1px solid var(--white);

  border-color: ${({ variant = 'primary', disabled }) =>
    disabled
      ? '#F2F2F3'
      : variant === 'primary'
        ? 'var(--prim4)'
        : variant === 'secondary'
          ? '#6c668540'
          : variant === 'danger'
            ? '#ff4d4f'
            : variant === 'transparent'
              ? 'none'
              : variant === 'success'
                ? '#52c41a'
                : 'var(--prim4)'};

  &:hover {
    filter: ${({ disabled }) => (disabled ? 'none' : 'brightness(90%)')};
  }

  &:active {
    filter: ${({ disabled }) => (disabled ? 'none' : 'brightness(80%)')};
  }

  @media only screen and (min-width: 800px) {
    height: ${({ size = 'auto' }) =>
      size === 'sm'
        ? '40px'
        : size === 'smd'
          ? '47px'
          : size === 'md'
            ? '52px'
            : size === 'lg'
              ? '64px'
              : '56px'};

    font-size: ${({ size = 'auto' }) =>
      size === 'sm'
        ? '16px'
        : size === 'smd'
          ? '18px'
          : size === 'md'
            ? '16px'
            : size === 'lg'
              ? '22px'
              : '20px'};

    padding: ${({ size = 'auto' }) =>
      size === 'sm'
        ? '0 16px'
        : size === 'smd'
          ? '6px 24px'
          : size === 'md'
            ? '10px 18px'
            : size === 'lg'
              ? '16px 24px'
              : '13px 22px'};
  }
`;

export default Button;
